import { jsxs as e, jsx as o } from "react/jsx-runtime";
import { Svg as t } from "../../utils/svg-wrapper.js";
const s = ({ className: r }) => /* @__PURE__ */ e(t, { className: r, height: "24", viewBox: "0 0 24 24", width: "24", children: [
  /* @__PURE__ */ o(
    "path",
    {
      d: "M9.16992 14.83L14.8299 9.17",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ o(
    "path",
    {
      d: "M14.8299 14.83L9.16992 9.17",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  ),
  /* @__PURE__ */ o(
    "path",
    {
      d: "M9 22L15 22C20 22 22 20 22 15L22 9C22 4 20 2 15 2L9 2C4 2 2 4 2 9L2 15C2 20 4 22 9 22Z",
      stroke: "inherit",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5"
    }
  )
] });
export {
  s as CloseSquareIcon
};
//# sourceMappingURL=close-square.js.map
